import classNames from 'classnames';
import { useAppContext } from 'providers/AppProvider';
import { Navbar } from 'react-bootstrap';
import logo_dark from 'assets/svgs/a1_logo_dark.svg';
import logo_light from 'assets/svgs/a1_logo_light.png';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarToggleButton from './NavbarToggleButton';
import { Link } from 'react-router-dom';

const NavbarBrand = () => {
  const {
    config: { navbarTopShape, navbarPosition, isDark }
  } = useAppContext();
  const { breakpoints } = useBreakpoints();

  return (
    <>
      <div className="navbar-logo">
        {breakpoints.down('lg') && <NavbarToggleButton />}
        <Navbar.Brand
          as={Link}
          to="/"
          className={classNames({
            'me-1 me-sm-3 w-100':
              navbarTopShape === 'slim' || navbarPosition === 'horizontal'
          })}
        >
          {navbarTopShape === 'slim' ? (
            <></>
          ) : (
            <span className=" w-100">
              <img
                src={isDark ? logo_dark : logo_light}
                alt="phoenix"
                className="h-55"
              />
            </span>
          )}
        </Navbar.Brand>
      </div>
    </>
  );
};

export default NavbarBrand;
